var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx } from "react/jsx-runtime";
import { ButtonBase } from '@mui/material';
import { KeypadButton as BaseKeypadButton } from 'hx-ui';
import { cn } from 'hx-util';
import { IoMdBackspace } from 'react-icons/io';
export function KeypadButton(props) {
    var _a;
    if (props.shortcut === 'Backspace') {
        return (_jsx(ButtonBase, __assign({ className: "rounded-full", onClick: props.onClick }, { children: _jsx(IoMdBackspace, {}) })));
    }
    return (_jsx(BaseKeypadButton, __assign({}, props, { className: cn({
            active: props.shortcut === '5' && !((_a = props.selectedNumbers) === null || _a === void 0 ? void 0 : _a.length),
        }, props.className) })));
}
